import { axiosInstance } from "@helpers/axios-instance";
import type { AssetGroup, HouseholdContact, DataAwareResponse } from "@/types/types";
import { useQueryWithValidation } from "./useQueryWithValidation";

type AssetsData = {
  assetGroups: AssetGroup[];
  contacts: HouseholdContact[];
};

export function useAssets(householdExternalCode: string) {
  return useQueryWithValidation({
    queryKey: ["assets", householdExternalCode],
    queryFn: async () => {
      const data = await axiosInstance({
        method: "GET",
        url:  `Salesforce/Assets/${householdExternalCode}`,
      });

      return data.data as DataAwareResponse<AssetsData>;
    },
    enabled: !!householdExternalCode,
  });
}
